import React from "react";

/**
 * Returns an empty wrapper around children. Useful when applying conditional wrappers.
 */
export const EmptyWrapper = ({ children }: { children: React.ReactNode }) => <>{children}</>;
